import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

function MorosityResidence({ address, total, expectedPayment, grandTotal }) {
  return (
    <Col className="residence-element">
      <Row>
        <Col lg={6}>{address}</Col>
        <Col lg={2}>${expectedPayment.toFixed(2)}</Col>
        <Col lg={2}>${grandTotal.toFixed(2)}</Col>
        <Col lg={2}>${total.toFixed(2)}</Col>
      </Row>
    </Col>
  );
}

export default MorosityResidence;
